var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.357474 0.376282C0.24416 0.494757 0.154257 0.635501 0.0929154 0.790452C0.031574 0.945403 -8.98238e-07 1.11152 -8.82937e-07 1.27928C-8.67636e-07 1.44704 0.031574 1.61316 0.0929155 1.76811C0.154257 1.92306 0.24416 2.0638 0.357474 2.18228L8.44663 10.6613C8.53669 10.7559 8.64366 10.8309 8.76141 10.8821C8.87917 10.9333 9.00541 10.9597 9.1329 10.9597C9.26038 10.9597 9.38662 10.9333 9.50438 10.8821C9.62214 10.8309 9.72911 10.7559 9.81916 10.6613L17.9083 2.18228C18.3853 1.68231 18.3853 0.876245 17.9083 0.376281C17.4313 -0.123683 16.6623 -0.123683 16.1854 0.376281L9.12803 7.76351L2.0707 0.366081C1.60346 -0.12368 0.824718 -0.123683 0.357474 0.376282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.bbe2647c169a895e09d9f2d52fa22135.svg";
export { ForwardRef as ReactComponent };